import {
    constructSearchUrl,
    useLocationContext,
    useRunSearch,
} from '@eventbrite/search-takeover';
import { getLayer, isStatsigInitialized, logEvent } from '@eventbrite/statsig';
import React from 'react';
import { LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT } from '../../constants';
import { SUGGESTED_SEARCHES } from './models';
import './SecondaryNav.scss';

interface SuggestedItemResponse {
    e: React.UIEvent<HTMLAnchorElement>;
    url: string;
    id: string;
    slug?: string;
    dates?: string;
    tags?: string[];
    price?: string;
    q?: string;
}

const VARIANTS = {
    CONTROL: 0,
    SEARCH: 1,
    BROWSE: 2,
};

export const SecondaryNav: React.FunctionComponent = () => {
    const secondaryNavVariant = getLayer(
        LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT.layer,
        LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT.param,
        LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT.defaultValue,
    );

    const { location } = useLocationContext();
    const handleSearch = useRunSearch();

    const handleItemClick = (val: SuggestedItemResponse) => {
        const { e, url, id, ...search } = val;
        e.preventDefault();

        handleSearch({
            url,
            search,
            analytics: {
                action: 'QuickSearchClicked',
                label: id,
            },
        });

        logEvent(
            LISTING_PAGE_PERSONALIZATION_SECONDARY_NAV_EXPERIMENT.event,
            null,
            {
                category: id,
            },
        );
    };

    return (
        <>
            {isStatsigInitialized() &&
            secondaryNavVariant !== VARIANTS.CONTROL ? (
                <nav className="secondary-nav">
                    <ul className="secondary-nav__categories">
                        {SUGGESTED_SEARCHES.map(({ content, value, id }) => {
                            let url = constructSearchUrl({
                                search: value,
                                location: location,
                            });

                            // if url is search page
                            if (secondaryNavVariant === VARIANTS.SEARCH) {
                                url = `${url}?page=1`;
                            }

                            // if url is browse page
                            if (
                                secondaryNavVariant === VARIANTS.BROWSE &&
                                id !== 'today' &&
                                id !== 'this_weekend'
                            ) {
                                url = url
                                    .replace('/d/', '/b/')
                                    .replace('--events', '');
                            }

                            return (
                                <li key={id}>
                                    <a
                                        href={url}
                                        onClick={(e) =>
                                            handleItemClick({
                                                ...value,
                                                url: url,
                                                id,
                                                e,
                                            })
                                        }
                                    >
                                        {content}
                                    </a>
                                </li>
                            );
                        })}
                    </ul>
                </nav>
            ) : null}
        </>
    );
};
